import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { DealSurveyAnswer } from "~/models/Survey";

const paths = {
	index: "/deals/:deal_id/deal_survey_answers"
};

type TIndex = (id: number | null) => SwrReturnType<DealSurveyAnswer[]>;
type ReturnType = {
	index: TIndex;
};

export const useDealSurveyAnswers = (): ReturnType => {
	const index: TIndex = (dealId: number | null) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, isLoading, error } = useSWR<DealSurveyAnswer[]>(
			dealId === null ? null : paths.index.replace(":deal_id", String(dealId))
		);
		return {
			data: data ?? null,
			error,
			isLoading,
			mutate
		};
	};
	return { index };
};
